import { useNavigate, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import "./Sidebar.css";
import owl_logo from "../../images/HOA Owl Logo.svg";
import hamburger from "../../images/hamburger.svg";
import newchat from "../../images/new.png";
import { TextField, Box ,CircularProgress} from "@mui/material";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  clearChatWindow,
  setClearAns,
  setChatHistory,
  setChatMessages,
} from "../../Services/ChatSession/chatHistorySlice"; //  Import action
import { selectSessionId } from "../../Redux/store";
import {
  setSessionData,
  setClearSessionData,
  storeSessionResponse,
} from "../../Services/ChatSession/chatDataSlice";
import {
  setSessionId,
  // storeSessionResponse,
} from "../../Services/ChatSession/sessionSlice";
import {getUserChatHistoryWithUserSession ,getUserChatHistory} from "../../Apis/chatServices";


function Sidebarcomp({ isCollapsed, onToggle, refetch }) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const clearAns = useSelector((state) => state.chatHistory.clearAns); // Sidebar data safe rahega
  const [messages, setMessages] = useState([]);
  const [query, setQuery] = useState("");
  // const [chatHistory, setChatHistory] = useState([]);
  const navigate = useNavigate();
  const Ai_session_id = useSelector((state) => state.session.sessionId);
  const Ai_chatHistory = useSelector((state) => state.chatHistory);
  // const sessionResponse = useSelector((state) => state.);
  const sessionResponse = useSelector(
    (state) => state.chatMessages.sideBarHistory
  );
  const userDetails = useSelector(
    (state) => state.fetchProfileData?.data?.data
  );

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const chatHistory = useSelector((state) => state.chatHistory.messages) || [];
  let sessionId = useSelector(selectSessionId);
  // const [sessionData, setSessionData] = useState(null);
  const userId = localStorage.getItem("user_id");
  const [filteredChatHistory, setFilteredChatHistory] = useState([]);
  const location = useLocation(); // Get current URL
  const status = userDetails?.status; // Extract status



  useEffect(() => {
    if (status === "deactivated") {
      

      localStorage.removeItem("access_token");
      localStorage.removeItem("accessToken");
    }
  }, [status]);

  const handleClick = () => {
    navigate("/user/chatboat");
  };

  useEffect(() => {
    setFilteredChatHistory(sessionResponse || []);
  }, [sessionResponse]);


  const handleNewChat = async () => {
 
    // await dispatch(setSessionData([]));
    await dispatch(setClearAns(true));
    await dispatch(setClearSessionData([]));
    await dispatch(setSessionId(null));
    localStorage.removeItem("chatHistory"); // Optionally clear LocalStorage
  

    // Check if current route is '/user/update-user'
    if (location.pathname === "/user/update-user") {
      navigate("/user/chatboat"); // Redirect
    } else if (location.pathname === "/user/user-profile") {
      navigate("/user/chatboat"); // Redirect
    } else if (location.pathname === "/user/change-password") {
      navigate("/user/chatboat"); // Redirect
    }
  };

 
  useEffect(() => {
    setFilteredChatHistory(sessionResponse || []);
  }, [sessionResponse]);

  useEffect(() => {
    const fetchData = async (user) => {
      setLoading(true); // Start loader
      try {
        // const response = await fetch(
        //   `http://0.0.0.0:9033/chat/user_sessions?user_id=${userId}`,
        //   {
        //     method: "GET",
        //     headers: {
        //       "Content-Type": "application/json",
             
        //     },
        //   }
        // );
        
        const response= await getUserChatHistory(user);
         
        if (response.status!==200) {
          throw new Error("Failed to fetch session data");
        }

        // const data = await response;

        //  Get today's date and calculate 7 days ago
        const sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

        //  Filter out sessions older than 7 days
        const recentSessions = response.data.sessions.filter(
          (session) => new Date(session.first_message.timestamp) >= sevenDaysAgo
        );

        //  Sort sessions by `timestamp` (latest first)
        const sortedSessions = response.data.sessions.sort(
          (a, b) =>
            new Date(b.first_message.timestamp) -
            new Date(a.first_message.timestamp)
        );
      
        dispatch(storeSessionResponse(sortedSessions));

        //  Correctly store session data
        setFilteredChatHistory(sortedSessions || []);
      } catch (error) {
        console.error("Error fetching session data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData(userId);
  }, [userId , refetch]);


  // Apply search filter only when a query is entered
  const searchedChats = query
    ? filteredChatHistory.filter((chat) =>
        chat?.first_message?.user_query
          .toLowerCase()
          .includes(query.toLowerCase())
      )
    : filteredChatHistory; // Show all chats when query is empty 


  //working
  const handleChatClick = async (user) => {
  
    // sessionId= user.session;
    //dispatch(setSessionId(chat.session_id)); // Selected session_id ko Redux me store karna
  
    dispatch(setClearAns(true));
    localStorage.removeItem("chatHistory"); // Optionally clear LocalStorage


  
    try {
      // const response = await fetch(
      //   // `https://sdeiaiml.com:9036/chat_history?user_id=${userId}&session_id=${user.session}`,
      //   `http://0.0.0.0:9033/chat/chat_history?user_id=${userId}&session_id=${user.session}`,
      //   {
      //     method: "GET",
      //     headers: {
      //       "Content-Type": "application/json",
      //       // Authorization agar zaroori ho toh yahan token add karein
      //     },
      //   }
      // );

      const response = await getUserChatHistoryWithUserSession(userId ,user.session);


      // if (!response.ok) {
      //   throw new Error("Failed to fetch session data");
      // }

      const data =  await response.data;
    
      await dispatch(setSessionId(user.session));
      // Yahan aap state ya Redux mein data store kar sakte hain
      await dispatch(setSessionData(data.chat_history)); // Store data in state
      // dispatch(setChatMessages(data.messages || [])); // Agar messages array ho to update karein
    } catch (error) {
      console.error("Error fetching session data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* {isCollapsed ? (
        <button className="btn-collapsed" onClick={onToggle}>
          <img
            src={hamburger}
            alt="hamburger_icon"
            className="toggle-icon-sidebar"
          />
        </button>
      ) : (
        <></>
      )} */}
      {isCollapsed ? (
        <button className="btn-collapsed" onClick={onToggle}>
          <img
            src={hamburger}
            alt="hamburger_icon"
            className="toggle-icon-sidebar"
          />
        </button>
      ) : null}
      {isCollapsed && (
        <button className="btn-collapsed" onClick={onToggle}>
          <img
            src={hamburger}
            alt="hamburger_icon"
            className="toggle-icon-sidebar"
          />
        </button>
      )}

      <div
        // className={`sidebar ${
        //   windowWidth <= 767 || isCollapsed ? "collapsed" : ""
        // }`}
        className={`sidebar ${isCollapsed ? "collapsed" : ""}`}
      >
        <button onClick={onToggle}>
          <img
            src={hamburger}
            alt="hamburger_icon"
            className="toggle-icon-sidebar"
          />
        </button>
        <div className="inner-wrapper-sidebar">
          <div className="logo">
            <img
              src={owl_logo}
              alt="logo"
              onClick={handleClick}
              style={{ cursor: "pointer" }}
            />
          </div>

          {/* Search Bar */}
          <div className="d-flex justify-content-center gap-2">
            <Box className="search-container mt-3 ">
              <TextField
                variant="outlined"
                placeholder="Search"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                className="search-input"
              />
            </Box>
            <div className="newChat mt-3 d-flex align-items-center">
              <img
                src={newchat}
                alt="New Chat"
                onClick={handleNewChat}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>

          {/* Chat History Section */}
          <div className="chat-history">
            <h4>History</h4>
            {/* <ul>
              {Ai_chatHistory?.messages.map((chat, index) => (
                <li key={index}>
                  <span>{chat.user}</span> <br/>
                  
                </li>
              ))}
            </ul> */}
       {loading ? (
              <div style={{ textAlign: "center", padding: "20px" }}>
                <CircularProgress size ={20} />
                <p style={{ marginTop: "10px" }}>Loading chat history...</p>
              </div>
            ) : (
            <ul>
              {searchedChats.length > 0 ? (
                searchedChats.map((chat, index) => (
                  <li key={index} onClick={() => handleChatClick(chat)}>
                    <span style={{ cursor: "pointer" }}>
                      {/* {chat.first_message?.user_query || "No message"} */}
                      {/* {chat.first_message?.user_query
            ? chat.first_message.user_query.split(" ").slice(0, 4).join(" ") + "..."
            : "No message"} */}
                      {chat.first_message?.user_query
                        ? chat.first_message.user_query.length > 23
                          ? chat.first_message.user_query.substring(0, 23) +
                            "..."
                          : chat.first_message.user_query
                        : "No message"}
                    </span>
                    <br />
                  </li>
                ))
              ) : (
                <p>No results found</p> // No results case handled
              )}
            </ul>)}
          </div>
        </div>
      </div>
    </>
  );
}

export default Sidebarcomp;
